import {
    gql
} from "@apollo/client";

export const DELETE_TYPE_PRICE = gql`
    mutation gqlDeleteTypePriceById($sNameKey: String!) {
        code: gqlDeleteTypePriceById(sNameKey: $sNameKey)
    }
`;

export const INSERT_TYPE_PRICE = gql`
    mutation gqlInsertTypePrice($price: PriceInput) {
        code: gqlInsertTypePrice(price: $price)
    }
`;

export const UPDATE_TYPE_PRICE = gql`
    mutation gqlUpdateTypePrice($price: PriceInput) {
        code: gqlUpdateTypePrice(price: $price)
    }
`;